import { gql } from "@shane32/graphql";

export const AddPaymentMutation = gql`
    mutation (
        $address: AddressInputGraph!
        $paymentType: PaymentTypeEnum!
        $nonce: String!
        $deviceData: String!
    ) {
        v1 {
            paymentMethod {
                add(
                    address: $address
                    paymentType: $paymentType
                    nonce: $nonce
                    deviceData: $deviceData
                ) {
                    id
                    accountNameOrEmail
                    address {
                        id
                        country {
                            id
                            name
                        }
                        firstName
                        lastName
                        company
                        email
                        address1
                        address2
                        city
                        stateProvince {
                            id
                            name
                            abbreviation
                        }
                        zipPostalCode
                        phoneNumber
                        createdOnUtc
                    }
                    paymentType
                    creditCardType
                    creditCardLast4
                    creditCardExp
                    displayOrder
                    createdOnUtc
                    validShippingAddresses {
                        id
                    }
                }
            }
        }
    }
`;

export interface IAddress {
    id: string;
    country: {
        id: string;
        name: string;
    };
    firstName: string;
    lastName: string;
    company: string | null;
    email: string;
    address1: string | null;
    address2: string | null;
    city: string | null;
    stateProvince: {
        id: string;
        name: string;
        abbreviation: string | null;
    } | null;
    zipPostalCode: string | null;
    phoneNumber: string | null;
    createdOnUtc: string;
}

export interface IPaymentMethod {
    id: string;
    accountNameOrEmail: string | null;
    address: IAddress;
    paymentType: "CREDIT_CARD" | "PAY_PAL" | "APPLE_PAY" | "GOOGLE_PAY";
    creditCardType: string | null;
    creditCardLast4: string | null;
    creditCardExp: string | null;
    displayOrder: number;
    createdOnUtc: string;
    validShippingAddresses: Array<{ id: string }>;
}

export interface IAddPaymentMutationResult {
    v1: {
        paymentMethod: {
            add: IPaymentMethod;
        };
    };
}

export type IAddPaymentMutationVariables =
    | IAddPaymentMutationCreditCardVariables
    | IAddPaymentMutationPayPalVariables;

export interface IAddPaymentMutationCreditCardVariables {
    paymentType: "CREDIT_CARD";
    nonce: string;
    address: {
        countryId: string;
        firstName: string;
        lastName: string;
        company?: string | null;
        address1: string;
        address2?: string | null;
        city: string;
        stateProvinceId?: string | null;
        zipPostalCode: string;
        phoneNumber: string;
        emailAddress?: string | null;
    };
    deviceData: string;
}

export interface IAddPaymentMutationPayPalVariables {
    paymentType: "PAY_PAL";
    nonce: string;
    address: {
        firstName: string;
        lastName: string;
        emailAddress: string;
    };
    deviceData: string;
}

export type IPaymentType =
    | "CREDIT_CARD"
    | "PAY_PAL"
    | "GOOGLE_PAY"
    | "APPLE_PAY";
